import { IApiRequestConfig } from '../api.types';

interface IOAuthAuthorizeRequest {
  redirect_uri: string;
  scope?: string;
}

export const oauthAuthorizeApi = (
  data: IOAuthAuthorizeRequest,
): IApiRequestConfig<unknown, IOAuthAuthorizeRequest> => ({
  apiRouteKey: 'oauthAuthorize',
  uri: 'json',
  action: 'oauth/authorize',
  method: 'post',
  data,
  v2: true,
});
